import { NotFoundElementDataType } from '@/components/sections/builder/elements/body/not-found/type';
import { ElementProps } from '@/components/sections/builder/types';
import { WrapperChild } from '@/components/sections/builder/wrapper';
import { cn, hexToRgba } from '@/lib/utils';
import { useBuilderStore } from '@/stores/builder';
import React from 'react';
import { shallow } from 'zustand/shallow';

export default function NotFoundElementContent({ element, theme, preview }: ElementProps) {
  const childs = element.childs;
  const data = element.data as NotFoundElementDataType;

  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
    }),
    shallow
  );

  const themeData = preview ? builder.theme : theme;

  return (
    <>
      <section
        className={cn(
          'flex flex-col',
          data.background?.type === 'color' && 'background-color',
          data.background?.type === 'image' && 'background-image',
          data.background?.backgroundLayout === 'grid' && 'theme_layout_page_width mx-auto'
        )}
        style={
          {
            '--text-color': data.colorScheme?.text || '#000000',
            '--text-secondary-color': data.colorScheme?.textSecondary || '#666666',
            '--bg-color': data.colorScheme?.background || '#ffffff',
            '--bg-overlay':
              `${hexToRgba(data.overlay, (data?.overlayOpacity ?? 0) / 100)}` ||
              'rgba(0, 0, 0, 0.5)',
            '--btn-label': data.colorScheme?.btnSolidlabel || '#000000',
            '--btn-bg': data.colorScheme?.btnSolidBackgroud || '#ffffff',
            '--btn-outline': data.colorScheme?.btnOutline || '#000000',
          } as React.CSSProperties
        }
      >
        <div
          className='theme_layout_page_width container relative mx-auto min-h-[calc(100vh_-_350px)] duration-100'
          style={
            {
              padding: `${data.padding?.top || 0}px ${data.padding?.right || 0}px ${
                data.padding?.bottom || 0
              }px ${data.padding?.left || 0}px`,
            } as React.CSSProperties
          }
        >
          {data.overlay && <div className={cn('absolute inset-0 bg-[--bg-overlay]')} />}
          <div
            className={cn(
              'my-2 flex w-full flex-col gap-4',
              data.alignment === 'left' && 'text-left',
              (data.alignment === 'center' || !data.alignment) && 'text-center',
              data.alignment === 'right' && 'text-right'
            )}
          >
            {(childs || []).map((child) => (
              <WrapperChild
                key={child.id}
                child={{
                  ...child,
                  parentData: data,
                  theme: themeData,
                }}
                parentType={element.type}
                preview={preview}
              />
            ))}
          </div>
        </div>
      </section>

      <style jsx>
        {`
          .background-color {
            background-color: ${data.background?.backgroundColor !== ''
              ? data.background?.backgroundColor
              : data.colorScheme?.background};
            --tw-bg-opacity: ${data.background?.backgroundOpacity};
          }
          .background-image {
            background-image: url(${data.background?.backgroundImage});
            background-repeat: no-repeat;
            background-size: ${data.background?.backgroundSize};
            background-position: ${data.background?.backgroundPosition};
            background-attachment: ${data.background?.backgroundAttachment};
          }
        `}
      </style>
    </>
  );
}
